// extracted by mini-css-extract-plugin
export default {"versionSelectorSection":"versionSection_versionSelectorSection__fS8mG"};